module.exports = __webpack_public_path__ + "img/advantage2Blue.5aa6b786.png";